import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { CustomDialog } from '../../../components/StyledComponents';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';

const ConfirmRemoveInvationDialog = ({ open = true, onClose, onConfirm, loading = false, rowId }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (onConfirm) onConfirm();  
  };

  return (
    <CustomDialog maxWidth="sm" open={open} onClose={onClose} keepMounted>
      <DialogTitle>
        <div className="flex justify-between">
          <div className="flex items-center gap-4">
            <p className="text-xl font-semibold">
              {t('common.remove-invation')}
            </p>
          </div>
          <GrayIconButton onClick={onClose}>
            <CloseIcon />
          </GrayIconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        <p className="pt-5">{t('common.confirm-remove-invation-message')}</p>
      </DialogContent>

      <DialogActions>
        <div className="flex gap-2 px-4 py-4">
          <ControlpanelSecondaryButton onClick={onClose} disabled={loading}>
            <CloseIcon />
            <p>{t('button.cancel')}</p>
          </ControlpanelSecondaryButton>
          <ControlpanelPrimaryButton onClick={handleConfirm} disabled={loading}>
            <DoneIcon />
            <p>{t('button.confirm')}</p>
          </ControlpanelPrimaryButton>
        </div>
      </DialogActions>
    </CustomDialog>
  );
};

export default ConfirmRemoveInvationDialog;
